
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/channel-integrations",
      function () {
        return require("private-next-pages/docs/channel-integrations.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/channel-integrations"])
      });
    }
  